import React from "react";

export default function About() {
  return (
    <section id="about" className="paper-section" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-5">
            <div className="border border-paperline p-1 bg-paper">
              <img
                src="https://customer-assets.emergentagent.com/job_blockchain-audit-10/artifacts/zde5d3tv_1778197290565.png"
                alt="John Sauderton — Principal, Sauderton Forensics"
                className="w-full aspect-square object-cover"
                data-testid="about-portrait"
              />
            </div>
            <div className="mt-6 grid grid-cols-3 border-t border-paperline">
              {[
                ["20+ YR", "FULL-STACK"],
                ["P2SH / SEGWIT", "SPECIALIST"],
                ["2010–2020", "LEGACY BTC"],
              ].map(([a, b]) => (
                <div key={a} className="border-r last:border-r-0 border-paperline py-4 pr-4">
                  <div className="font-serif-display text-base leading-tight">{a}</div>
                  <div className="mono-label-paper mt-1">{b}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:col-start-7">
            <div className="mono-label-paper mb-6">§ 04 · PRINCIPAL</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.1]" data-testid="about-heading">
              John Sauderton
            </h2>
            <div className="mono-label-paper mt-4">TECHNICAL CONSULTANT · DIGITAL ASSET LITIGATION</div>

            <div className="mt-10 space-y-6 text-paperink/85 text-base leading-relaxed">
              <p>
                John Sauderton is a technical consultant for high-stakes digital asset
                litigation. His expertise is derived from <span className="text-paperink font-medium">20+ years
                of full-stack development and blockchain systems analysis</span>. John is a
                Bitcoin O.G. — an original cypherpunk from the very first days of Bitcoin&apos;s existence.
              </p>
              <p>
                He is a specialist in <span className="text-paperink font-medium">Legacy Bitcoin Infrastructure
                (2010 – 2020)</span> with deep working knowledge of P2SH multisig constructions,
                early mining configurations, SegWit migration patterns, BIP32/39/44 derivation
                paths, early Bitcoin Core wallet formats, and the forensic tracing of complex
                transaction histories across the pre-mainstream era of the chain.
              </p>
              <p>
                His engagements support private investigators and family-law counsel with
                <span className="text-paperink font-medium"> Technical Forensic Mapping</span> — reconstructing
                wallet provenance, tracing comingled flows through legacy mixers and bridge
                hops, and producing auditable work-product for matrimonial discovery,
                estate / probate matters, and fraud recovery.
              </p>
              <p className="text-paperink/65 text-sm">
                The practice is deliberately boutique. He does not advertise retail recovery
                services, does not custody client funds, and does not publish client names.
                For redacted sample work-product, submit a Case Feasibility Inquiry below.
              </p>
              <p className="font-serif-display italic text-paperink text-2xl pt-2">
                If it&apos;s hidden — John will find it.
              </p>
            </div>

            <div className="mt-12 border-t border-paperline pt-6 flex items-center gap-4">
              <span className="w-6 h-6 border border-paperink relative">
                <span className="absolute inset-1 bg-paperink" />
              </span>
              <span className="font-serif-display">John Sauderton</span>
              <span className="mono-label-paper">· PRINCIPAL</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
